import { AUDIT_GROUPLESS_FIELDS_FLAT } from './audit_fields'

export const BREED_BASE_FIELDS_FLAT = [
	{
		field: '_id',
		label: 'ID',
		nofilter: true, // TODO ObjectId, filter must be augmented on server
		readonly: true
	},
	{
		field: 'name_en',
		label: 'Name',
	},
	{
		field: 'name_hu',
		label: 'Name (hun)',
	},
	{
		field: 'species',
		label: 'Species',
		type: 'enum',
		values: [
			'dog',
			'horse',
			'pig',
			'wolf',
			'cat',
			'human',
			'other',
			'cattle',
			'not_animal',
			'special'
		]
	},
	{
		field: 'wiki',
		label: 'Wiki Link',
		type: 'link'
	},
	{
		field: 'comment',
		label: 'Comment',
	},
]

export const BREED_DOG_FIELDS_FLAT = [
	{
		field: 'abbreviation',
		label: 'Abbreviation',
	},
	{
		field: 'akc',
		label: 'Akc',
	},
	{
		field: 'fci_main',
		label: 'FCI main',
		type: 'number'
	},
	{
		field: 'parker1',
		label: 'Parker 1',
	},
	{
		field: 'parker2',
		label: 'Parker 2',
		type: 'number'
	},
	{
		field: 'parker3',
		label: 'Parker 3',
	},
	{
		field: 'vonholdt',
		label: 'Vonholdt',
	},
	{
		field: 'eltype',
		label: 'ELType',
	},
	{
		field: 'height',
		label: 'Height',
		type: 'number'
	},
	{
		field: 'weight',
		label: 'Weight',
		type: 'number'
	},
	{
		field: 'cooperativitiy',
		label: 'Cooperativitiy',
		type: 'number'
	},
	{
		field: 'root_dist',
		label: 'Root distance',
		type: 'number'
	},
	{
		field: 'cephalic_index',
		label: 'Cephalic Index',
		type: 'number'
	},
	{
		field: 'head_shape',
		label: 'Head Shape',
	},
	{
		field: 'log_br_vol_imputed',
		label: 'log_br_vol_imputed',
		type: 'number'
	},
	{
		field: 'res_brain',
		label: 'Brain resolution? (res_brain)',
		type: 'number'
	},
	{
		field: 'median_lifespan',
		label: 'Median lifespan',
		type: 'number'
	},
	{
		field: 'age_at_senior',
		label: 'Senior age',
		type: 'number'
	},
]

export const BREED_FIELDS_FLAT = [
	...BREED_BASE_FIELDS_FLAT,
	...BREED_DOG_FIELDS_FLAT,
]

export const BREED_LISTED_FIELDS_FLAT = [
	...BREED_BASE_FIELDS_FLAT,
	...BREED_DOG_FIELDS_FLAT,
	...AUDIT_GROUPLESS_FIELDS_FLAT
]
